<template>
  <section class="cards">
    <div class="cards__inner">
      <slot />
    </div>
  </section>
</template>

<script>
import Card from '@/components/partials/Card.vue'

export default {
  name: 'Cards',
  components: {
    Card
  },
  props: {
    cards: {
      type: Array,
      default: () => []
    },
    icon: {
      type: String,
      default: 'arrow-right'
    },
    type: {
      type: String,
      default: 'large'
    }
  }
}
</script>

<docs>
  ```vue
    <cards>
      <card type="small" title="Card 1" />
      <card type="small" title="Card 2" :image="{url: 'https://picsum.photos/200/300', alt:'Alt text'}" />
      <card type="small" title="Card 3" />
    </cards>

  <cards>
    <card type="large" subtitle="Subtitle 1" title="Card 1"/>
    <card type="large" subtitle="Subtitle 2" icon="arrow-right" title="Card 2"/>
    <card type="large" subtitle="Subtitle 3" icon="arrow-right" title="Card 3" :image="{url: 'https://picsum.photos/200/300', alt:'Alt text'}"/>
  </cards>
  ```
  ```scss
  // Variable defaults:
  $cards-overlap: rem(-40);
  ```
</docs>


<style lang="scss">

.hero {
  & + .cards, & + .large-cards {
    margin-top: $cards-overlap;
  }
}
.cards {
  position: relative;
  z-index: 1;
  width: 100%;
  overflow-x: auto;
  margin-top: $small-space-top;
  scroll-snap-type: x mandatory;
  &__inner {
    display: flex;
    flex-wrap: wrap;
    width: 1000vw;
    width: max-content;
    padding: 0 $padding;
  }
}
</style>
